import { useTranslation } from 'react-i18next'

import { useNotification } from '../../../../hooks'
import { getItemsIds } from '../../../../utils/common'
import {
  getDocFlowRequestLinksErrorNotification,
  getDocFlowRequestsPayload,
} from '../../../../utils/docFlow'
import { AttachServiceRequestsModal } from '../../../Request'
import { connectDocFlowRequests } from '../../DocFlow.api'

export function useDocFlowConnectRequests({
  onCloseModal,
  onReload,
  onSetModal,
}) {
  const { t } = useTranslation()

  const { handleAddErrorNotification, handleAddSuccessNotification } =
    useNotification()

  function handleOpenDocFlowConnectRequests({ connectedRequests, docFlowId }) {
    async function handleAttach({ selected }) {
      return connectDocFlowRequests({
        data: getDocFlowRequestsPayload(getItemsIds(selected)),
        id: docFlowId,
      })
        .then(() => {
          onCloseModal()

          onReload().finally(() => {
            handleAddSuccessNotification({
              title: t('Notification.DocFlowsTitleConnectRequestsKey', {
                count: selected.length,
              }),
            })
          })
        })
        .catch(error => {
          handleAddErrorNotification(
            getDocFlowRequestLinksErrorNotification({ error, t })
          )
        })
    }

    onSetModal(
      <AttachServiceRequestsModal
        multipleSelection
        excludeIds={getItemsIds(connectedRequests)}
        restoreAttention={false}
        onAttach={handleAttach}
        onClose={onCloseModal}
      />
    )
  }

  return { handleOpenDocFlowConnectRequests }
}
